export type IdentityChangeAction = 'unchanged' | 'renamed' | 'merged';

export interface IdentityChangePreviewUser {
  id: number;
  name: string | null;
  email: string;
  projectId: number | null;
  projectName: string;
  isActive: boolean;
}

export interface IdentityChangePreview {
  action: IdentityChangeAction;
  conflictOnCurrentProject: boolean;
  currentUsers: IdentityChangePreviewUser[];
  destinationUsers: IdentityChangePreviewUser[];
}

export interface IdentityChangeFields {
  email: boolean;
  name: boolean;
  password: boolean;
}

export const IDENTITY_PROJECT_CONFLICT_MESSAGE = 'Ya existe un usuario con este email en este proyecto';

export const identityFieldsFromPreview = (
  preview: IdentityChangePreview,
  changing: IdentityChangeFields
): IdentityChangeFields => ({
  email: preview.action === 'merged' || preview.action === 'renamed',
  name: changing.name,
  password: changing.password,
});

export const identityChangeNeedsConfirm = (preview: IdentityChangePreview, changing: IdentityChangeFields): boolean => {
  if (preview.conflictOnCurrentProject) return false;
  if (preview.action === 'merged' || preview.action === 'renamed') return true;
  return changing.name || changing.password;
};
